import moment from 'moment';
import 'moment/locale/fr';

export const date = (d) => (d ? moment(d).format('DD/MM/YY') : '—');
export const dateTime = (d) => (d ? moment(d).format('DD/MM/YY HH:mm') : '—');
export const ago = (d) => (d ? moment(d).locale('fr').fromNow() : '—');

/** 3725 → « 1 h 02 », 75 → « 1 min 15 », 9 → « 9 s » */
export function duration(seconds) {
    const s = Math.max(0, Math.round(seconds || 0));
    if (s < 60) return `${s} s`;
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    if (h) return `${h} h ${String(m).padStart(2, '0')}`;
    return `${m} min ${String(s % 60).padStart(2, '0')}`;
}

/** Position de lecture : 3725 → « 1:02:05 » */
export function clock(seconds) {
    const s = Math.max(0, Math.round(seconds || 0));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = String(s % 60).padStart(2, '0');
    return h ? `${h}:${String(m).padStart(2, '0')}:${r}` : `${m}:${r}`;
}

export const percent = (pos, dur) => (dur ? Math.min(100, Math.round((pos / dur) * 100)) : 0);

/** Événements du journal du compte (PrimeStation : services/accountLog.js) */
export const EVENTS = {
    payment: { label: 'Paiement', tone: 'gold' },
    premium: { label: 'Premium activé', tone: 'gold' },
    login: { label: 'Connexion', tone: 'ok' },
    login_failed: { label: 'Mauvais mot de passe', tone: 'warn' },
    login_blocked: { label: 'Connexion refusée (bloqué)', tone: 'ko' },
    register: { label: 'Inscription', tone: 'ok' },
    logout: { label: 'Déconnexion', tone: 'muted' },
    password: { label: 'Mot de passe changé', tone: 'info' },
    reset: { label: 'Mot de passe réinitialisé', tone: 'info' },
    blocked: { label: 'Bloqué', tone: 'ko' },
    switch: { label: 'Connexion · autre appareil coupé', tone: 'warn' },
    sharing: { label: 'Partage possible', tone: 'warn' },
    suspended: { label: 'Bloqué temporairement', tone: 'ko' },
    admin: { label: 'Action admin', tone: 'admin' },
};

export const titleOf = (content, episode) => `${content?.title || '—'}${episode?.label ? ` · ${episode.label}` : ''}`;
